/* tslint:disable */
/* eslint-disable */
/**
 * Dataland Backend API documentation
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../../../../../../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../../../../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../../../../../../base';
// @ts-ignore
import type { CompanyAssociatedDataEutaxonomyFinancials202673Data } from '../../../../../../org/dataland/datalandfrontend/openApiClient/backend/model';
// @ts-ignore
import type { DataAndMetaInformationEutaxonomyFinancials202673Data } from '../../../../../../org/dataland/datalandfrontend/openApiClient/backend/model';
// @ts-ignore
import type { DataMetaInformation } from '../../../../../../org/dataland/datalandfrontend/openApiClient/backend/model';
// @ts-ignore
import type { ErrorResponse } from '../../../../../../org/dataland/datalandfrontend/openApiClient/backend/model';
// @ts-ignore
import type { ExportJobInfo } from '../../../../../../org/dataland/datalandfrontend/openApiClient/backend/model';
// @ts-ignore
import type { ExportLatestRequestData } from '../../../../../../org/dataland/datalandfrontend/openApiClient/backend/model';
// @ts-ignore
import type { ExportRequestData } from '../../../../../../org/dataland/datalandfrontend/openApiClient/backend/model';
/**
 * EutaxonomyFinancials202673DataControllerApi - axios parameter creator
 */
export const EutaxonomyFinancials202673DataControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} companyId The unique identifier under which a company can be found on Dataland.
         * @param {boolean} [showOnlyActive] Boolean parameter. If set to true or empty, only currently active data is returned. If set to false, all data is returned regardless of active status.
         * @param {string} [reportingPeriod] The relevant reporting period (e.g. a fiscal year).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCompanyEutaxonomyFinancials202673Data: async (companyId: string, showOnlyActive?: boolean, reportingPeriod?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('getAllCompanyEutaxonomyFinancials202673Data', 'companyId', companyId)
            const localVarPath = `/data/eutaxonomy-financials-2026-73/companies/{companyId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            if (showOnlyActive !== undefined) {
                localVarQueryParameter['showOnlyActive'] = showOnlyActive;
            }

            if (reportingPeriod !== undefined) {
                localVarQueryParameter['reportingPeriod'] = reportingPeriod;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} dataId The unique identifier of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyAssociatedEutaxonomyFinancials202673Data: async (dataId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dataId' is not null or undefined
            assertParamExists('getCompanyAssociatedEutaxonomyFinancials202673Data', 'dataId', dataId)
            const localVarPath = `/data/eutaxonomy-financials-2026-73/{dataId}`
                .replace(`{${"dataId"}}`, encodeURIComponent(String(dataId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} reportingPeriod The relevant reporting period (e.g. a fiscal year).
         * @param {string} companyId The unique identifier under which a company can be found on Dataland.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyAssociatedEutaxonomyFinancials202673DataByDimensions: async (reportingPeriod: string, companyId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportingPeriod' is not null or undefined
            assertParamExists('getCompanyAssociatedEutaxonomyFinancials202673DataByDimensions', 'reportingPeriod', reportingPeriod)
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('getCompanyAssociatedEutaxonomyFinancials202673DataByDimensions', 'companyId', companyId)
            const localVarPath = `/data/eutaxonomy-financials-2026-73/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            if (reportingPeriod !== undefined) {
                localVarQueryParameter['reportingPeriod'] = reportingPeriod;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} identifier Unique identifier to find a company.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestAvailableCompanyAssociatedEutaxonomyFinancials202673Data: async (identifier: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identifier' is not null or undefined
            assertParamExists('getLatestAvailableCompanyAssociatedEutaxonomyFinancials202673Data', 'identifier', identifier)
            const localVarPath = `/data/eutaxonomy-financials-2026-73/latest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            if (identifier !== undefined) {
                localVarQueryParameter['identifier'] = identifier;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CompanyAssociatedDataEutaxonomyFinancials202673Data} companyAssociatedDataEutaxonomyFinancials202673Data 
         * @param {boolean} [bypassQa] If true, data is not sent to QA.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCompanyAssociatedEutaxonomyFinancials202673Data: async (companyAssociatedDataEutaxonomyFinancials202673Data: CompanyAssociatedDataEutaxonomyFinancials202673Data, bypassQa?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyAssociatedDataEutaxonomyFinancials202673Data' is not null or undefined
            assertParamExists('postCompanyAssociatedEutaxonomyFinancials202673Data', 'companyAssociatedDataEutaxonomyFinancials202673Data', companyAssociatedDataEutaxonomyFinancials202673Data)
            const localVarPath = `/data/eutaxonomy-financials-2026-73`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            if (bypassQa !== undefined) {
                localVarQueryParameter['bypassQa'] = bypassQa;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(companyAssociatedDataEutaxonomyFinancials202673Data, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ExportRequestData} exportRequestData 
         * @param {boolean} [keepValueFieldsOnly] If set to true, data is to be exported without additional information like comments on the data or the data\&#39;s qa status.
         * @param {boolean} [includeAliases] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postExportJobCompanyAssociatedEutaxonomyFinancials202673DataByDimensions: async (exportRequestData: ExportRequestData, keepValueFieldsOnly?: boolean, includeAliases?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'exportRequestData' is not null or undefined
            assertParamExists('postExportJobCompanyAssociatedEutaxonomyFinancials202673DataByDimensions', 'exportRequestData', exportRequestData)
            const localVarPath = `/data/eutaxonomy-financials-2026-73/export-jobs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            if (keepValueFieldsOnly !== undefined) {
                localVarQueryParameter['keepValueFieldsOnly'] = keepValueFieldsOnly;
            }

            if (includeAliases !== undefined) {
                localVarQueryParameter['includeAliases'] = includeAliases;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(exportRequestData, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ExportLatestRequestData} exportLatestRequestData 
         * @param {boolean} [keepValueFieldsOnly] If set to true, data is to be exported without additional information like comments on the data or the data\&#39;s qa status.
         * @param {boolean} [includeAliases] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postExportLatestJobCompanyAssociatedEutaxonomyFinancials202673DataByDimensions: async (exportLatestRequestData: ExportLatestRequestData, keepValueFieldsOnly?: boolean, includeAliases?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'exportLatestRequestData' is not null or undefined
            assertParamExists('postExportLatestJobCompanyAssociatedEutaxonomyFinancials202673DataByDimensions', 'exportLatestRequestData', exportLatestRequestData)
            const localVarPath = `/data/eutaxonomy-financials-2026-73/export-latest-jobs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            if (keepValueFieldsOnly !== undefined) {
                localVarQueryParameter['keepValueFieldsOnly'] = keepValueFieldsOnly;
            }

            if (includeAliases !== undefined) {
                localVarQueryParameter['includeAliases'] = includeAliases;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(exportLatestRequestData, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EutaxonomyFinancials202673DataControllerApi - functional programming interface
 */
export const EutaxonomyFinancials202673DataControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EutaxonomyFinancials202673DataControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} companyId The unique identifier under which a company can be found on Dataland.
         * @param {boolean} [showOnlyActive] Boolean parameter. If set to true or empty, only currently active data is returned. If set to false, all data is returned regardless of active status.
         * @param {string} [reportingPeriod] The relevant reporting period (e.g. a fiscal year).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllCompanyEutaxonomyFinancials202673Data(companyId: string, showOnlyActive?: boolean, reportingPeriod?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DataAndMetaInformationEutaxonomyFinancials202673Data>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllCompanyEutaxonomyFinancials202673Data(companyId, showOnlyActive, reportingPeriod, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EutaxonomyFinancials202673DataControllerApi.getAllCompanyEutaxonomyFinancials202673Data']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} dataId The unique identifier of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompanyAssociatedEutaxonomyFinancials202673Data(dataId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyAssociatedDataEutaxonomyFinancials202673Data>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompanyAssociatedEutaxonomyFinancials202673Data(dataId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EutaxonomyFinancials202673DataControllerApi.getCompanyAssociatedEutaxonomyFinancials202673Data']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} reportingPeriod The relevant reporting period (e.g. a fiscal year).
         * @param {string} companyId The unique identifier under which a company can be found on Dataland.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompanyAssociatedEutaxonomyFinancials202673DataByDimensions(reportingPeriod: string, companyId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyAssociatedDataEutaxonomyFinancials202673Data>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompanyAssociatedEutaxonomyFinancials202673DataByDimensions(reportingPeriod, companyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EutaxonomyFinancials202673DataControllerApi.getCompanyAssociatedEutaxonomyFinancials202673DataByDimensions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} identifier Unique identifier to find a company.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLatestAvailableCompanyAssociatedEutaxonomyFinancials202673Data(identifier: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyAssociatedDataEutaxonomyFinancials202673Data>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLatestAvailableCompanyAssociatedEutaxonomyFinancials202673Data(identifier, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EutaxonomyFinancials202673DataControllerApi.getLatestAvailableCompanyAssociatedEutaxonomyFinancials202673Data']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CompanyAssociatedDataEutaxonomyFinancials202673Data} companyAssociatedDataEutaxonomyFinancials202673Data 
         * @param {boolean} [bypassQa] If true, data is not sent to QA.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postCompanyAssociatedEutaxonomyFinancials202673Data(companyAssociatedDataEutaxonomyFinancials202673Data: CompanyAssociatedDataEutaxonomyFinancials202673Data, bypassQa?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataMetaInformation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postCompanyAssociatedEutaxonomyFinancials202673Data(companyAssociatedDataEutaxonomyFinancials202673Data, bypassQa, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EutaxonomyFinancials202673DataControllerApi.postCompanyAssociatedEutaxonomyFinancials202673Data']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ExportRequestData} exportRequestData 
         * @param {boolean} [keepValueFieldsOnly] If set to true, data is to be exported without additional information like comments on the data or the data\&#39;s qa status.
         * @param {boolean} [includeAliases] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postExportJobCompanyAssociatedEutaxonomyFinancials202673DataByDimensions(exportRequestData: ExportRequestData, keepValueFieldsOnly?: boolean, includeAliases?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExportJobInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postExportJobCompanyAssociatedEutaxonomyFinancials202673DataByDimensions(exportRequestData, keepValueFieldsOnly, includeAliases, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EutaxonomyFinancials202673DataControllerApi.postExportJobCompanyAssociatedEutaxonomyFinancials202673DataByDimensions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ExportLatestRequestData} exportLatestRequestData 
         * @param {boolean} [keepValueFieldsOnly] If set to true, data is to be exported without additional information like comments on the data or the data\&#39;s qa status.
         * @param {boolean} [includeAliases] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postExportLatestJobCompanyAssociatedEutaxonomyFinancials202673DataByDimensions(exportLatestRequestData: ExportLatestRequestData, keepValueFieldsOnly?: boolean, includeAliases?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExportJobInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postExportLatestJobCompanyAssociatedEutaxonomyFinancials202673DataByDimensions(exportLatestRequestData, keepValueFieldsOnly, includeAliases, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EutaxonomyFinancials202673DataControllerApi.postExportLatestJobCompanyAssociatedEutaxonomyFinancials202673DataByDimensions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EutaxonomyFinancials202673DataControllerApi - factory interface
 */
export const EutaxonomyFinancials202673DataControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EutaxonomyFinancials202673DataControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} companyId The unique identifier under which a company can be found on Dataland.
         * @param {boolean} [showOnlyActive] Boolean parameter. If set to true or empty, only currently active data is returned. If set to false, all data is returned regardless of active status.
         * @param {string} [reportingPeriod] The relevant reporting period (e.g. a fiscal year).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCompanyEutaxonomyFinancials202673Data(companyId: string, showOnlyActive?: boolean, reportingPeriod?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<DataAndMetaInformationEutaxonomyFinancials202673Data>> {
            return localVarFp.getAllCompanyEutaxonomyFinancials202673Data(companyId, showOnlyActive, reportingPeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} dataId The unique identifier of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyAssociatedEutaxonomyFinancials202673Data(dataId: string, options?: RawAxiosRequestConfig): AxiosPromise<CompanyAssociatedDataEutaxonomyFinancials202673Data> {
            return localVarFp.getCompanyAssociatedEutaxonomyFinancials202673Data(dataId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} reportingPeriod The relevant reporting period (e.g. a fiscal year).
         * @param {string} companyId The unique identifier under which a company can be found on Dataland.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyAssociatedEutaxonomyFinancials202673DataByDimensions(reportingPeriod: string, companyId: string, options?: RawAxiosRequestConfig): AxiosPromise<CompanyAssociatedDataEutaxonomyFinancials202673Data> {
            return localVarFp.getCompanyAssociatedEutaxonomyFinancials202673DataByDimensions(reportingPeriod, companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} identifier Unique identifier to find a company.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestAvailableCompanyAssociatedEutaxonomyFinancials202673Data(identifier: string, options?: RawAxiosRequestConfig): AxiosPromise<CompanyAssociatedDataEutaxonomyFinancials202673Data> {
            return localVarFp.getLatestAvailableCompanyAssociatedEutaxonomyFinancials202673Data(identifier, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompanyAssociatedDataEutaxonomyFinancials202673Data} companyAssociatedDataEutaxonomyFinancials202673Data 
         * @param {boolean} [bypassQa] If true, data is not sent to QA.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCompanyAssociatedEutaxonomyFinancials202673Data(companyAssociatedDataEutaxonomyFinancials202673Data: CompanyAssociatedDataEutaxonomyFinancials202673Data, bypassQa?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<DataMetaInformation> {
            return localVarFp.postCompanyAssociatedEutaxonomyFinancials202673Data(companyAssociatedDataEutaxonomyFinancials202673Data, bypassQa, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExportRequestData} exportRequestData 
         * @param {boolean} [keepValueFieldsOnly] If set to true, data is to be exported without additional information like comments on the data or the data\&#39;s qa status.
         * @param {boolean} [includeAliases] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postExportJobCompanyAssociatedEutaxonomyFinancials202673DataByDimensions(exportRequestData: ExportRequestData, keepValueFieldsOnly?: boolean, includeAliases?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<ExportJobInfo> {
            return localVarFp.postExportJobCompanyAssociatedEutaxonomyFinancials202673DataByDimensions(exportRequestData, keepValueFieldsOnly, includeAliases, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExportLatestRequestData} exportLatestRequestData 
         * @param {boolean} [keepValueFieldsOnly] If set to true, data is to be exported without additional information like comments on the data or the data\&#39;s qa status.
         * @param {boolean} [includeAliases] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postExportLatestJobCompanyAssociatedEutaxonomyFinancials202673DataByDimensions(exportLatestRequestData: ExportLatestRequestData, keepValueFieldsOnly?: boolean, includeAliases?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<ExportJobInfo> {
            return localVarFp.postExportLatestJobCompanyAssociatedEutaxonomyFinancials202673DataByDimensions(exportLatestRequestData, keepValueFieldsOnly, includeAliases, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EutaxonomyFinancials202673DataControllerApi - interface
 */
export interface EutaxonomyFinancials202673DataControllerApiInterface {
    /**
     * 
     * @param {string} companyId The unique identifier under which a company can be found on Dataland.
     * @param {boolean} [showOnlyActive] Boolean parameter. If set to true or empty, only currently active data is returned. If set to false, all data is returned regardless of active status.
     * @param {string} [reportingPeriod] The relevant reporting period (e.g. a fiscal year).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAllCompanyEutaxonomyFinancials202673Data(companyId: string, showOnlyActive?: boolean, reportingPeriod?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<DataAndMetaInformationEutaxonomyFinancials202673Data>>;

    /**
     * 
     * @param {string} dataId The unique identifier of the dataset.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCompanyAssociatedEutaxonomyFinancials202673Data(dataId: string, options?: RawAxiosRequestConfig): AxiosPromise<CompanyAssociatedDataEutaxonomyFinancials202673Data>;

    /**
     * 
     * @param {string} reportingPeriod The relevant reporting period (e.g. a fiscal year).
     * @param {string} companyId The unique identifier under which a company can be found on Dataland.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCompanyAssociatedEutaxonomyFinancials202673DataByDimensions(reportingPeriod: string, companyId: string, options?: RawAxiosRequestConfig): AxiosPromise<CompanyAssociatedDataEutaxonomyFinancials202673Data>;

    /**
     * 
     * @param {string} identifier Unique identifier to find a company.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLatestAvailableCompanyAssociatedEutaxonomyFinancials202673Data(identifier: string, options?: RawAxiosRequestConfig): AxiosPromise<CompanyAssociatedDataEutaxonomyFinancials202673Data>;

    /**
     * 
     * @param {CompanyAssociatedDataEutaxonomyFinancials202673Data} companyAssociatedDataEutaxonomyFinancials202673Data 
     * @param {boolean} [bypassQa] If true, data is not sent to QA.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postCompanyAssociatedEutaxonomyFinancials202673Data(companyAssociatedDataEutaxonomyFinancials202673Data: CompanyAssociatedDataEutaxonomyFinancials202673Data, bypassQa?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<DataMetaInformation>;

    /**
     * 
     * @param {ExportRequestData} exportRequestData 
     * @param {boolean} [keepValueFieldsOnly] If set to true, data is to be exported without additional information like comments on the data or the data\&#39;s qa status.
     * @param {boolean} [includeAliases] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postExportJobCompanyAssociatedEutaxonomyFinancials202673DataByDimensions(exportRequestData: ExportRequestData, keepValueFieldsOnly?: boolean, includeAliases?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<ExportJobInfo>;

    /**
     * 
     * @param {ExportLatestRequestData} exportLatestRequestData 
     * @param {boolean} [keepValueFieldsOnly] If set to true, data is to be exported without additional information like comments on the data or the data\&#39;s qa status.
     * @param {boolean} [includeAliases] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postExportLatestJobCompanyAssociatedEutaxonomyFinancials202673DataByDimensions(exportLatestRequestData: ExportLatestRequestData, keepValueFieldsOnly?: boolean, includeAliases?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<ExportJobInfo>;

}

/**
 * EutaxonomyFinancials202673DataControllerApi - object-oriented interface
 */
export class EutaxonomyFinancials202673DataControllerApi extends BaseAPI implements EutaxonomyFinancials202673DataControllerApiInterface {
    /**
     * 
     * @param {string} companyId The unique identifier under which a company can be found on Dataland.
     * @param {boolean} [showOnlyActive] Boolean parameter. If set to true or empty, only currently active data is returned. If set to false, all data is returned regardless of active status.
     * @param {string} [reportingPeriod] The relevant reporting period (e.g. a fiscal year).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAllCompanyEutaxonomyFinancials202673Data(companyId: string, showOnlyActive?: boolean, reportingPeriod?: string, options?: RawAxiosRequestConfig) {
        return EutaxonomyFinancials202673DataControllerApiFp(this.configuration).getAllCompanyEutaxonomyFinancials202673Data(companyId, showOnlyActive, reportingPeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} dataId The unique identifier of the dataset.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCompanyAssociatedEutaxonomyFinancials202673Data(dataId: string, options?: RawAxiosRequestConfig) {
        return EutaxonomyFinancials202673DataControllerApiFp(this.configuration).getCompanyAssociatedEutaxonomyFinancials202673Data(dataId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} reportingPeriod The relevant reporting period (e.g. a fiscal year).
     * @param {string} companyId The unique identifier under which a company can be found on Dataland.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCompanyAssociatedEutaxonomyFinancials202673DataByDimensions(reportingPeriod: string, companyId: string, options?: RawAxiosRequestConfig) {
        return EutaxonomyFinancials202673DataControllerApiFp(this.configuration).getCompanyAssociatedEutaxonomyFinancials202673DataByDimensions(reportingPeriod, companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} identifier Unique identifier to find a company.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getLatestAvailableCompanyAssociatedEutaxonomyFinancials202673Data(identifier: string, options?: RawAxiosRequestConfig) {
        return EutaxonomyFinancials202673DataControllerApiFp(this.configuration).getLatestAvailableCompanyAssociatedEutaxonomyFinancials202673Data(identifier, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompanyAssociatedDataEutaxonomyFinancials202673Data} companyAssociatedDataEutaxonomyFinancials202673Data 
     * @param {boolean} [bypassQa] If true, data is not sent to QA.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postCompanyAssociatedEutaxonomyFinancials202673Data(companyAssociatedDataEutaxonomyFinancials202673Data: CompanyAssociatedDataEutaxonomyFinancials202673Data, bypassQa?: boolean, options?: RawAxiosRequestConfig) {
        return EutaxonomyFinancials202673DataControllerApiFp(this.configuration).postCompanyAssociatedEutaxonomyFinancials202673Data(companyAssociatedDataEutaxonomyFinancials202673Data, bypassQa, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExportRequestData} exportRequestData 
     * @param {boolean} [keepValueFieldsOnly] If set to true, data is to be exported without additional information like comments on the data or the data\&#39;s qa status.
     * @param {boolean} [includeAliases] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postExportJobCompanyAssociatedEutaxonomyFinancials202673DataByDimensions(exportRequestData: ExportRequestData, keepValueFieldsOnly?: boolean, includeAliases?: boolean, options?: RawAxiosRequestConfig) {
        return EutaxonomyFinancials202673DataControllerApiFp(this.configuration).postExportJobCompanyAssociatedEutaxonomyFinancials202673DataByDimensions(exportRequestData, keepValueFieldsOnly, includeAliases, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExportLatestRequestData} exportLatestRequestData 
     * @param {boolean} [keepValueFieldsOnly] If set to true, data is to be exported without additional information like comments on the data or the data\&#39;s qa status.
     * @param {boolean} [includeAliases] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postExportLatestJobCompanyAssociatedEutaxonomyFinancials202673DataByDimensions(exportLatestRequestData: ExportLatestRequestData, keepValueFieldsOnly?: boolean, includeAliases?: boolean, options?: RawAxiosRequestConfig) {
        return EutaxonomyFinancials202673DataControllerApiFp(this.configuration).postExportLatestJobCompanyAssociatedEutaxonomyFinancials202673DataByDimensions(exportLatestRequestData, keepValueFieldsOnly, includeAliases, options).then((request) => request(this.axios, this.basePath));
    }
}

